import { POPULATION_TYPE } from "@/common/models";
import { SharedState } from "@/common/state";
import {
  DrillDownMenuItem,
  UseDrillDownMenu,
} from "@/components/root/drilldown-menu/drilldown-menu.state";

import { ToastType, UseToast } from "@/components/root/toast/toast.state";

const investigate_menu_item: DrillDownMenuItem = {
  disable: false,
  isCategory: false,
  name: "Investigate",
  icon: "Investigation",
  subItems: [],
  isPremium: false,
  action: "investigate",
};

export const employee_menu = async (p: {
  item: any;
  event: MouseEvent;
  info_types: string[];
}) => {
  const res = await UseDrillDownMenu().show({
    menu: [investigate_menu_item],
    event: p.event,
  });
  if (res.didUserSelectedAnAction) {
    SharedState.investigation.investigate({
      ...p.item,
      type: POPULATION_TYPE.LABEL,
    });
  }
};
